export default __webpack_public_path__ + "static/media/gif6_slow.5c39c8bc.gif";